import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { TostMsg } from "../../../../App";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  addEmployeeAcademics,
  employeeAcademics,
} from "../Service/profileService";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";

function AddEducation() {
  const { GUID } = useParams();
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [showContent, setSeleteContent] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [academicsDatalist, setAcademicsDatalist] = useState();
  const [dateError, setDateError] = useState(false);
  let history = useHistory();

  useEffect(() => {
    setIsloading(true);
    if (GUID?.length >= 0) {
      setTimeout(() => {
        setIsloading(false);
        getEmployeeAcademics();
        GetMasterSystemAlertList("edit_education", 1);
      }, 1000);
    } else {
      setIsloading(false);
      GetMasterSystemAlertList("Education__Added", 1);
      employeeInfoForm.resetForm();
    }
  }, []);

  async function getEmployeeAcademics() {
    setIsloading(true);
    const params = {
      OrgId: userDetails.OrgId,
      AcadId: Number(GUID) ?? 0,
      EmpId: userDetails?.EmpId,
    };
    try {
      const response = await employeeAcademics(params);
      let academicDetails = response?.Data;
      setAcademicsDatalist(academicDetails);
      if (academicDetails[0]?.id) {
        const editAcademicData = {
          Id: academicDetails[0]?.id ?? 0,
          OrgId: userDetails.OrgId,
          EmpId: userDetails.EmpId,
          ModifiedBy: userDetails.EmpId,
          schoolName: academicDetails[0]?.SchoolName,
          degree: academicDetails[0]?.Degree,
          degreeType: academicDetails[0]?.DegreeType,
          startDate: academicDetails[0]?.StartDate
            ? new Date(academicDetails[0]?.StartDate)
                .toISOString()
                .split("T")[0]
            : null,
          endDate: academicDetails[0]?.EndDate
            ? new Date(academicDetails[0]?.EndDate).toISOString().split("T")[0]
            : null,
          majorSubject: academicDetails[0]?.MajorSubject,
          marks: academicDetails[0]?.Marks,
        };
        employeeInfoForm.setValues(editAcademicData);
        setIsloading(false);
      }
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const educationValidation = Yup.object().shape({
    schoolName: Yup.string().required("School/Institute name is required."),
    degree: Yup.string().required("Degree is required."),
    degreeType: Yup.string().required("Field of study is required."),
    startDate: Yup.date().required("Start date is required"),
    endDate: Yup.date()
      .required("End date is required")
      .min(Yup.ref("startDate"), "End date cannot be before start date"),
    majorSubject: "",
  });

  const employeeInfoForm = useFormik({
    initialValues: {
      schoolName: "",
      degree: "",
      degreeType: "",
      startDate: "",
      endDate: "",
      majorSubject: "",
      marks: "",
    },
    validationSchema: educationValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      let endDateValue;
      endDateValue = new Date(data.endDate).toISOString().split("T")[0];
      const body = {
        Id: data?.Id ?? 0,
        OrgId: userDetails.OrgId,
        Image: "",
        EmpId: userDetails.EmpId,
        SchoolName: data?.schoolName,
        Degree: data?.degree,
        DegreeType: data?.degreeType,
        StartDate: data?.startDate ?? new Date(data.startDate).toISOString(),
        EndDate: endDateValue ?? "",
        MajorSubject: data?.majorSubject,
        Marks: data?.marks,
        ModifiedBy: userDetails.EmpId,
      };
      if (data?.startDate > endDateValue) {
        setDateError(true);
        setIsloading(false);
        return;
      }
      try {
        await addEmployeeAcademics(body);
        setIsloading(false);
        if (data?.Id) {
          GetMasterSystemAlertList("Education_Updated", 0);
        } else {
          GetMasterSystemAlertList("Add_Education", 0);
        }
        setIsloading(false);
        history.push(`/Profile/${userDetails.GUID}`);
      } catch (err) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      } finally {
        setIsloading(false);
      }
    },
  });

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  return (
    <>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center mb-4">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">
                  {" "}
                  {GUID ? "Edit" : "Add"} Education
                </h2>
                <p className="text-center">{showContent}</p>
              </div>
              <div className="rightside-tabs">
                <Link to={`/Profile/${userDetails.GUID}`}>
                  <button className="back-newticket w-auto float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>{" "}
                    Back
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <form onSubmit={employeeInfoForm.handleSubmit}>
              <div className="row mt-2 justify-content-center">
                <div className="col-xl-9">
                  <div className="row gx-3 gy-1">
                    <div className="mb-2 col-md-12">
                      <div className="cover-form">
                        <label className="form-label">
                          School/Institute Name
                          <i className="inValidError">*</i>
                        </label>
                        <input
                          type="text"
                          cols="1"
                          rows="4"
                          name="schoolName"
                          className={
                            "form-control" +
                            (employeeInfoForm.errors.schoolName &&
                            employeeInfoForm.touched.schoolName
                              ? " is-invalid"
                              : "")
                          }
                          onChange={employeeInfoForm.handleChange}
                          value={employeeInfoForm.values.schoolName}
                          placeholder="School/Institute name goes here..."
                        />
                      </div>
                      <div className="invalid-feedback">
                        {employeeInfoForm.errors.schoolName &&
                        employeeInfoForm.touched.schoolName
                          ? employeeInfoForm.errors.schoolName
                          : null}
                      </div>
                    </div>

                    <div className="mb-2 col-md-6">
                      <div className="cover-form">
                        <label className="form-label">
                          Degree<i className="inValidError">*</i>
                        </label>
                        <input
                          id="degree"
                          name="degree"
                          className={
                            "form-control wide" +
                            (employeeInfoForm.errors.degree &&
                            employeeInfoForm.touched.degree
                              ? " is-invalid"
                              : "")
                          }
                          onChange={employeeInfoForm.handleChange}
                          value={employeeInfoForm.values.degree}
                          placeholder="Degree"
                        />
                      </div>
                      <div className="invalid-feedback">
                        {employeeInfoForm.errors.degree &&
                        employeeInfoForm.touched.degree
                          ? employeeInfoForm.errors.degree
                          : null}
                      </div>
                    </div>

                    <div className="mb-2 col-md-6">
                      <div className="cover-form">
                        <label className="form-label">
                          Field of Study
                          <i className="inValidError">*</i>
                        </label>
                        <input
                          id="degreeType"
                          name="degreeType"
                          className={
                            "form-control wide" +
                            (employeeInfoForm.errors.degreeType &&
                            employeeInfoForm.touched.degreeType
                              ? " is-invalid"
                              : "")
                          }
                          onChange={employeeInfoForm.handleChange}
                          value={employeeInfoForm.values.degreeType}
                          placeholder="Field of study"
                        />
                      </div>
                      <div className="invalid-feedback">
                        {employeeInfoForm.errors.degreeType &&
                        employeeInfoForm.touched.degreeType
                          ? employeeInfoForm.errors.degreeType
                          : null}
                      </div>
                    </div>

                    <div className="mb-2 col-md-6">
                      <div className="cover-form">
                        <label className="form-label">
                          Start Date
                          <i className="inValidError">*</i>
                        </label>
                        <input
                          type="date"
                          name="startDate"
                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                          className={`form-control ${
                            employeeInfoForm.errors.startDate &&
                            employeeInfoForm.touched.startDate
                              ? "is-invalid"
                              : ""
                          }`}
                          onChange={employeeInfoForm.handleChange}
                          onBlur={employeeInfoForm.handleBlur}
                          value={employeeInfoForm.values.startDate || ""}
                        />
                      </div>
                      <div className="invalid-feedback">
                        {employeeInfoForm.touched.startDate &&
                          employeeInfoForm.errors.startDate}
                      </div>
                    </div>
                    <div className="mb-2 col-md-6">
                      <div className="cover-form">
                        <label className="form-label">
                          End Date
                          <i className="inValidError">*</i>
                        </label>
                        <input
                          type="date"
                          name="endDate"
                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                          className={`form-control ${
                            employeeInfoForm.errors.endDate &&
                            employeeInfoForm.touched.endDate
                              ? "is-invalid"
                              : ""
                          }`}
                          onChange={employeeInfoForm.handleChange}
                          onBlur={employeeInfoForm.handleBlur}
                          value={employeeInfoForm.values.endDate || ""}
                        />
                      </div>
                      <div className="invalid-feedback">
                        {employeeInfoForm.touched.endDate &&
                          employeeInfoForm.errors.endDate}
                      </div>
                    </div>
                    {dateError ? (
                      <span className="invalid-feedback">
                        {" "}
                        * EndDate is geater than or equal to Start Date.
                      </span>
                    ) : (
                      ""
                    )}
                    <div className="mb-2 col-md-12">
                      <div className="cover-form">
                        <label className="form-label">Address</label>
                        <textarea
                          type="text"
                          rows={7}
                          name="majorSubject"
                          className={"form-control h-auto"}
                          placeholder="Address"
                          onChange={employeeInfoForm.handleChange}
                          value={employeeInfoForm.values.majorSubject}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 mt-3">
                  <div className="btns-grp">
                    <Link to={`/Profile/${userDetails.GUID}`}>
                      <button
                        className="add-click"
                        style={{ width: "115px" }}
                        fdprocessedid="5mw059"
                      >
                        Cancel
                      </button>
                    </Link>
                    {GUID ? (
                      <button
                        type="submit"
                        className="savebutton"
                        fdprocessedid="jjj57m"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="savebutton"
                        fdprocessedid="jjj57m"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Save"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {Isloading ? (
          <Suspense >
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default AddEducation;
